import { render, staticRenderFns } from "./topicGoodsModal.vue?vue&type=template&id=593db7e9&scoped=true"
import script from "./topicGoodsModal.vue?vue&type=script&lang=js"
export * from "./topicGoodsModal.vue?vue&type=script&lang=js"
import style0 from "./topicGoodsModal.vue?vue&type=style&index=0&id=593db7e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593db7e9",
  null
  
)

export default component.exports